export interface ILatestAction {
  actionDate: string
  text: string
}
